import { useRef } from 'react';
import {
  Box,
  Table,
  Pagination,
  TextInput,
  Button,
  MediaQuery
} from '@mantine/core';
import { useStyles } from './style';
import edit from '../../../assets/icons/edit.svg';
import view from '../../../assets/icons/view.svg';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { SearchIcon } from '../../../assets/icons/search';
import { data, statusClass, propertiesUserType } from './properties';
import { baseURL } from '../../../config/urls';
import { BiDollar } from 'react-icons/bi';

import {
  getHeader,
  doRedirectIfUnAuth,
  getUserType,
  getUserData
} from '../../../config/userSession';
import plusIcon from '../../../assets/icons/plus-icon.svg';
import { IconCheck, IconX } from '@tabler/icons-react';
import { notifications } from '@mantine/notifications';
import { noRecordFound } from '../../../utils/const';
import { useLocation } from 'react-router-dom';
import handleSearch from '../../../pages/common/Search';

function ManagerPropertyList() {
  const userType = getUserType();
  const { classes, theme } = useStyles(useStyles);
  const [activePage, setActivePage] = useState(1);
  const navigate = useNavigate();
  const [entries, setEntries] = useState([]);
  const [pageLoadEntries, setPageLoadEntries] = useState([]);
  const [totalPage, setTotalPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const cacheListing = useRef({});
  const params = new URLSearchParams();
  const user = getUserData();
  console.log(user);
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const email = queryParams.get('email');

  params.append('page', activePage);
  params.append('pSize', pageSize);
  params.append('email', email);

  const pageChangeHandler = (page) => {
    setActivePage(page);
  };

  const fetchContactForm = async () => {
    if (params in cacheListing) {
      setEntries(cacheListing[params]);
      setPageLoadEntries(cacheListing[params]);
      return;
    }
    const response = await fetch(
      `${baseURL}/property/manager-list?` + params.toString(),
      {
        method: 'GET',
        headers: getHeader()
      }
    );
    console.log(response);
    if (response.ok) {
      let contactFormListing = await response.json();
      console.log(contactFormListing);
      setEntries(contactFormListing.data);
      setPageLoadEntries(contactFormListing.data);
      setTotalPage((contactFormListing.totalCount + pageSize - 1) / pageSize);
      cacheListing[params] = contactFormListing.data;
    } else {
      doRedirectIfUnAuth(response.status);
    }
  };

  useEffect(() => {
    fetchContactForm();
  }, [activePage]);

  const getDaysUntilCurrentDueDate = (dueDayStr) => {
    const today = new Date();
    const dueDay = parseInt(dueDayStr); // from "23th" to 23

    // Construct full due date using this month and year
    const dueDate = new Date(today.getFullYear(), today.getMonth(), dueDay);

    // If due date has already passed this month, move to next month
    if (dueDate < today) {
      dueDate.setMonth(dueDate.getMonth() + 1);
    }

    // Calculate days left
    const timeDiff = dueDate - today;
    const daysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

    return daysLeft;
  };

  const rows = entries.map((element, index) => {
    const managerType = element.managerType;

    return (
      <tr
        className={index % 2 === 0 ? classes.tableRowWhite : classes.tableRow}
        key={`${element.propertName}${index}`}
      >
        <td className={classes.tableData}>{element.propertType}</td>
        <td className={classes.tableData}>{element.propertName}</td>
        <td className={classes.tableData}>
          {' '}
          {userType === propertiesUserType.landlord
            ? element.tenantName
            : element.landlordName}
        </td>
        <td className={classes.tableData}>
          <p
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              margin: 0
            }}
          >
            <BiDollar /> {element.oneTimeBreakup.totalAmount}
          </p>
        </td>
        <td className={classes.tableData}>
          {getDaysUntilCurrentDueDate(element.oneTimeBreakup.currentDueDate)}{' '}
          days
        </td>
        <td className={classes.tableData}>
          <p
            className={`${classes.status} ${statusClass(
              element.status.toLowerCase(),
              classes
            )}`}
          >
            {element.status}
          </p>
        </td>
        <td className={classes.tableData}>
          <Box className={classes.editAndView}>
            <Link
              to={
                element.status === 'DRAFT'
                  ? `/${userType.toLowerCase()}/property/${element.propertyId}`
                  : `/${userType.toLowerCase()}/property/${element.propertyId}`
              }
            >
              <img
                className={classes.action}
                src={managerType === 'LANDLORD_MANAGER' ? edit : view}
                alt="edit"
              />
            </Link>
          </Box>
        </td>
      </tr>
    );
  });

  const showNotification = (notificationType, message, title) => {
    let colorCode = notificationType == 'success' ? 'secondary.0' : 'red';
    notifications.show({
      id: 'addproperty-notification',
      withCloseButton: true,
      autoClose: 3000,
      title: title,
      message: message,
      color: colorCode,
      icon:
        notificationType == 'success' ? <IconCheck size="1.1rem" /> : <IconX />,
      style: { backgroundColor: theme.colors.background[0] },
      loading: false
    });
  };

  const handleAddNewProperty = async () => {
    const response = await fetch(
      `${baseURL}/account/getStripeConnectAccountStatus`,
      {
        method: 'GET',
        headers: getHeader()
      }
    );
    let connectStatus = await response.json();
    if (response.status === 200) {
      navigate('/landlord/add-property');
    } else {
      navigate('/landlord/profile');
      showNotification('failure', connectStatus.message, '');
    }
  };

  return (
    <Box className={classes.wrapper}>
      <Box className={classes.headerAndSearch}>
        <p className={classes.title}>{data.titles.propertyList}</p>
        <Box className={classes.searchAndFilter}>
          <TextInput
            icon={<SearchIcon />}
            onChange={(e) =>
              handleSearch(e, pageLoadEntries, setEntries, [
                'propertType',
                'status',
                'propertName',
                'landlordName',
                'tenantName'
              ])
            }
            radius={'xl'}
            className={classes.searchInput}
            placeholder={data.titles.search}
          />
        </Box>
      </Box>
      <Box className={classes.tableContainer}>
        <Table className={classes.table}>
          <thead className={classes.tableHead}>
            <tr>
              {data?.tableHeading[userType.toLowerCase()]?.map((heading) => {
                return <th className={classes.columnHeading}>{heading}</th>;
              })}
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </Table>
      </Box>
      {rows.length === 0 ? (
        <p className="no-record-found">{noRecordFound}</p>
      ) : (
        <Pagination
          size={'md'}
          defaultValue={activePage}
          onChange={pageChangeHandler}
          className={classes.pagination}
          siblings={1}
          total={totalPage}
        />
      )}
    </Box>
  );
}

export default ManagerPropertyList;
